import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageShell from "@/components/layout/PageShell";

const NotFound = () => (
  <PageShell>
    <main className="min-h-[70vh] flex items-center forr-canvas">
      <div className="max-w-[900px] mx-auto px-6 sm:px-10 lg:px-16 py-28 text-center">
        <div className="forr-overline">404 · Page not found</div>
        <h1 className="mt-8 font-display forr-text-ink text-4xl sm:text-6xl font-medium tracking-[-0.03em]">
          This page is no longer here.
        </h1>
        <p className="mt-6 mx-auto max-w-xl text-base sm:text-lg font-light forr-text-soft leading-relaxed">
          The address may be outdated, or the content may have moved into the
          current Adaptive Physiology framework.
        </p>
        <Link
          to="/"
          className="mt-10 forr-btn-primary inline-flex items-center gap-3 px-7 py-4 rounded-full text-sm font-semibold"
        >
          <ArrowLeft size={16} strokeWidth={2} />
          Return to Adaptive Physiology
        </Link>
      </div>
    </main>
  </PageShell>
);

export default NotFound;
